import React from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@ubisend/pulse-hooks';
import { Select } from '@ubisend/pulse-components';

const format = ({ id, name }) => ({ label: name, value: id });

const ImportSelect = ({ value, ...props }) => {
  const {
    data,
    isLoading,
    isSuccess
  } = useQuery({
    queryKey: [
      'imports'
    ]
  });

  return (
    <Select
      isClearable
      isLoading={isLoading}
      options={
        isSuccess
          ? data.data.filter(({ sections }) => sections.length > 0).map(format)
          : []
      }
      value={
        isSuccess && value && format(data.data.find(item => item.id === value))
      }
      {...props}
    />
  );
};

ImportSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ImportSelect;
